import * as consts from '../constants';
import initialState from './initialState';

export default function contractReducer(state = initialState.contractState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_CONTRACTS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_CONTRACTS_FAILED:
            return initialState.contractState;
        default:
            return state;
    }
}
